import { defineStore } from 'pinia'

export const cartStore = defineStore({
    id: 'cart',
    state: () => ({
        items: [],
        timestamp: null
    }),
    actions: {
        setItems(items) {
            this.items = items
        },
        setTimestamp() {
            this.timestamp = Date.now()
        },
        clearCart() {
            this.items = []
            this.timestamp = null
        }
    },
    getters: {
        getItems() {
            return this.items
        },
        getTotal() {
            if (!this.items || this.items.length === 0) return 0
            return this.items.reduce((total, item) => {
                return total
                    + parseFloat(item.plan_price || 0)
                    + parseFloat(item.activation_rate || 0)
                    + parseFloat(item.equipment_rate || 0)
            }, 0)
        },
        hasItems() {
            return this.items && this.items.length > 0
        }
    },
    persist: true
})
